var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page-detail-body-container container-app-search" },
    [
      !_vm.load_first
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "400px", width: "100%" }
            },
            [_vm._m(0)]
          )
        : _c(
            "div",
            { staticClass: "table-column dataset-column" },
            [
              _c(
                "v-client-table",
                {
                  staticClass: "jTable",
                  attrs: {
                    data: _vm.dataColumn,
                    columns: _vm.columns,
                    options: _vm.table_options
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "is_primary_key",
                      fn: function(props) {
                        return _c(
                          "div",
                          {},
                          [
                            props.row.type === "varchar"
                              ? _c("j-toggle", {
                                  class: {
                                    "disabled-primary":
                                      _vm.primaryHasBeenSet &&
                                      props.row.name !==
                                        _vm.datasetDetail.primary_key
                                  },
                                  attrs: {
                                    disabled:
                                      (_vm.primaryHasBeenSet &&
                                        props.row.name !==
                                          _vm.datasetDetail.primary_key) ||
                                      _vm.findRecord
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.setPrimary($event, props)
                                    }
                                  },
                                  model: {
                                    value: props.row.is_primary_key,
                                    callback: function($$v) {
                                      _vm.$set(props.row, "is_primary_key", $$v)
                                    },
                                    expression: "props.row.is_primary_key"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }
                    },
                    {
                      key: "action",
                      fn: function(props) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  props.row.name !== "created_at" &&
                                  props.row.name !== "updated_at" &&
                                  props.row.name !== "updated_by" &&
                                  props.row.name !== "created_by" &&
                                  !_vm.findRecord,
                                expression:
                                  "props.row.name !== 'created_at' &&\n          props.row.name !== 'updated_at' &&\n          props.row.name !== 'updated_by' &&\n          props.row.name !== 'created_by' &&\n        !findRecord"
                              }
                            ]
                          },
                          [
                            _c("img", {
                              staticClass: "cursor-pointer m__r--5",
                              attrs: {
                                src: require("@/assets/icon/query/edit.svg"),
                                width: "13"
                              },
                              on: {
                                click: function($event) {
                                  _vm.openDetail(props)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "cursor-pointer",
                              attrs: {
                                src: require("@/assets/icon/query/delete.svg"),
                                width: "13"
                              },
                              on: {
                                click: function($event) {
                                  _vm.deleteItem(props)
                                }
                              }
                            })
                          ]
                        )
                      }
                    }
                  ])
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "custom-search",
                      attrs: { slot: "beforeFilter" },
                      slot: "beforeFilter"
                    },
                    [
                      _c(
                        "b-form",
                        { attrs: { inline: "" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn grey btn-import-form",
                              on: { click: _vm.openModalColumn }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus fa-lg" }),
                              _vm._v(" Add Column\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddColumnModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(_vm._s(_vm.isDetail ? "UPDATE" : "CREATE") + " COLUMN")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.column_data.name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.column_data.name.$error,
                  "max-length": 255,
                  placeholder: "Name"
                },
                model: {
                  value: _vm.$v.column_data.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.column_data.name, "$model", $$v)
                  },
                  expression: "$v.column_data.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.column_data.type.$error } },
            [
              _c("label", [_vm._v(" Type ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  "error-required": _vm.$v.column_data.type.$error,
                  options: _vm.typeOptions,
                  placeholder: "Type"
                },
                model: {
                  value: _vm.$v.column_data.type.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.column_data.type, "$model", $$v)
                  },
                  expression: "$v.column_data.type.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-to-right m__t--10" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn gray m__r--5",
                  on: { click: _vm.closeCreateColumn }
                },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue",
                  on: { click: _vm.createColumnData }
                },
                [_vm._v("\n        Save\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6810b152", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6810b152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetColumn.vue
// module id = null
// module chunks = 